import { grey, red } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loginState, mobileState, WHState } from "./component/Atom/AtomState";
import LayoutDegign from "./component/Layout/LayoutDegign";
import ColorConsultResultPage from "./component/Page/ColorConsultResultPage";
import ConsultDetailPage from "./component/Page/ConsultDetailPage";
import ConsultPage from "./component/Page/ConsultPage";
import CustomerQuestionPage from "./component/Page/CustomerQuestionPage";
import CustomerResultPage from "./component/Page/CustomerResultPage";
import CustomersPage from "./component/Page/CustomersPage";
import CustomersDetailPage from "./component/Page/CustomersDetailPage";
import FitConsultResultPage from "./component/Page/FitConsultResultPage";
import HomePage from "./component/Page/HomePage";
import LoginPage from "./component/Page/LoginPage";
import MemberDetailPage from "./component/Page/MemberDetailPage";
import MemberPage from "./component/Page/MemberPage";
import NotFoundPage from "./component/Page/NotFoundPage";
import NoticeDetailPage from "./component/Page/NoticeDetailPage";
import NoticePage from "./component/Page/NoticePage";
import QuestionDetailPage from "./component/Page/QuestionDetailPage";
import QuestionPage from "./component/Page/QuestionPage";

const theme = createTheme({
  palette: {
    primary: {
      main: grey[900],
    },
    secondary: {
      main: red[500],
    },
  },
});

const App: React.FC = () => {
  const LoginState = useRecoilValue(loginState);
  const setMobileState = useSetRecoilState(mobileState);
  const [WH, setWH] = useRecoilState(WHState);
  const [Sidebar, setSidebar] = useState(WH.width >= 768);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMobileState(true);
        setSidebar(false);
      } else {
        setMobileState(false);
        setSidebar(true);
      }
      setWH({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <LayoutDegign Sidebar={Sidebar} setSidebar={(value) => setSidebar(value)}>
        <Routes>
          <Route path="/customer" element={<CustomerQuestionPage />} />
          {!LoginState ? (
            <Route path="/" element={<LoginPage />} />
          ) : (
            <Route path="/" element={<HomePage />} />
          )}
          <Route path="/CustomersPage" element={<CustomersPage />} />
          <Route
            path="/CustomersDetailPage"
            element={<CustomersDetailPage />}
          />
          <Route path="/MemberPage" element={<MemberPage />} />
          <Route path="/MemberDetailPage" element={<MemberDetailPage />} />
          <Route path="/QuestionPage" element={<QuestionPage />} />
          <Route path="/QuestionDetailPage" element={<QuestionDetailPage />} />
          <Route path="/NoticePage" element={<NoticePage />} />
          <Route path="/NoticeDetailPage" element={<NoticeDetailPage />} />
          <Route path="/ConsultPage" element={<ConsultPage />} />
          <Route path="/ConsultDetailPage" element={<ConsultDetailPage />} />
          <Route path="/CustomerResultPage" element={<CustomerResultPage />} />
          <Route
            path="/ColorConsultResultPage"
            element={<ColorConsultResultPage />}
          />
          <Route
            path="/FitConsultResultPage"
            element={<FitConsultResultPage />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </LayoutDegign>
    </ThemeProvider>
  );
};

export default App;
